/**
 *
 * @param text
 * @returns kabob-case
 */
export const paramCase = (text) => {
    return (text
        .match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)
        ?.join('-')
        .toLowerCase() || text);
};
/**
 *
 * @param text (from: camelCasing)
 * @returns string (to: Camel Casing)
 */
export const camelToWords = (text) => {
    return text.replace(/([a-z](?=[A-Z]))/g, '$1 ');
};
/**
 * wrap JSON.stringify try/catch
 * @param data
 * @returns
 */
export const stringify = (value, replacer, space) => {
    try {
        return JSON.stringify(value, replacer, space);
    }
    catch (error) {
        return value;
    }
};
//# sourceMappingURL=utils.js.map
